import { useEffect, useState } from 'react';
import { loadPublishedRoles, subscribeToPublishedRoles } from '../services/rolesService';
import { ROADMAP_LEARN_ROLES_FALLBACK } from '../components/Roadmap/roadmapLearnRoles';

/**
 * Load published roles from Firestore with optional realtime updates.
 * Falls back to static launch list when Firestore is empty or unreachable.
 *
 * @param {{ subscribe?: boolean }} [options]
 */
export default function usePublishedRoles({ subscribe = false } = {}) {
  const [roles, setRoles] = useState(ROADMAP_LEARN_ROLES_FALLBACK);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fromFirestore, setFromFirestore] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const applyList = (list) => {
      if (cancelled) return;
      if (list.length > 0) {
        setRoles(list);
        setFromFirestore(true);
      } else {
        setRoles(ROADMAP_LEARN_ROLES_FALLBACK);
        setFromFirestore(false);
      }
      setLoading(false);
    };

    if (subscribe) {
      const unsub = subscribeToPublishedRoles(
        applyList,
        (err) => {
          if (!cancelled) {
            setError(err);
            setRoles(ROADMAP_LEARN_ROLES_FALLBACK);
            setFromFirestore(false);
            setLoading(false);
          }
        }
      );
      return () => {
        cancelled = true;
        unsub();
      };
    }

    (async () => {
      try {
        const list = await loadPublishedRoles();
        applyList(list);
      } catch (err) {
        if (!cancelled) {
          setError(err);
          setRoles(ROADMAP_LEARN_ROLES_FALLBACK);
          setFromFirestore(false);
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [subscribe]);

  return { roles, loading, error, fromFirestore };
}
